export default "__VITE_ASSET__BgMZxUmj__"